export default {
  SECTION_WIDGET_ALBUM: {
    layout01: {
      cellWidth: {
        100: {
          allow: true,
          item: 4,
        },
        66.67: {
          allow: true,
          item: 2,
        },
        58.33: {
          allow: true,
          item: 2,
        },
        50: {
          allow: true,
          item: 2,
        },
        41.67: {
          allow: true,
          item: 1,
        },
        33.33: {
          allow: true,
          item: 1,
        },
        25: {
          allow: true,
          item: 1,
        },
        20: {
          allow: false,
        },
        16.66: {
          allow: false,
        },
      },
    },
    layout02: {
      cellWidth: {
        100: {
          allow: true,
          item: 3,
        },
        66.67: {
          allow: true,
          item: 2,
        },
        58.33: {
          allow: true,
          item: 2,
        },
        50: {
          allow: true,
          item: 2,
        },
        41.67: {
          allow: true,
          item: 1,
        },
        33.33: {
          allow: true,
          item: 1,
        },
        25: {
          allow: true,
          item: 1,
        },
        20: {
          allow: false,
        },
        16.66: {
          allow: false,
        },
      },
    },
    layout03: {
      cellWidth: {
        100: {
          allow: true,
          item: 6,
        },
        66.67: {
          allow: true,
          item: 3,
        },
        58.33: {
          allow: true,
          item: 3,
        },
        50: {
          allow: true,
          item: 3,
        },
        41.67: {
          allow: true,
          item: 2,
        },
        33.33: {
          allow: true,
          item: 2,
        },
        25: {
          allow: true,
          item: 1,
        },
        20: {
          allow: true,
          item: 1,
        },
        16.66: {
          allow: true,
          item: 1,
        },
      },
    },
  },
};
